<template>
  <component :is="expendituresData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="expendituresData === undefined">
      <h4 class="alert-heading">獲取薪金支出數據時出錯</h4>
      <div class="alert-body">
        找不到相關薪金支出記錄。請查看
        <b-link class="alert-link" :to="{ name: 'expenditures-list' }">
          薪金支出列表
        </b-link>
      </div>
    </b-alert>
    <expenditures-edit-tab-information
      v-if="expendituresData"
      :invoiceOptions="invoiceOptions"
      :workerOptions="workerOptions"
      :userOptions="userOptions"
      :approvalStatusOptions="approvalStatusOptions"
      :expenditures-data="expendituresData"
      :expenseStatusOptions="expenseStatusOptions"
      :salaryReceiveMethodOptions="salaryReceiveMethodOptions"
      class="p-sm-2"
      @refetch-data="refetchData"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import expenditureStoreModule from "../expenditureStoreModule";
import expendituresEditTabInformation from "./expendituresEditTabInformation.vue";

export default {
  components: {
    expendituresEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const expendituresData = ref({ id: 0 });
    const expenditures = {
      id: 0,
      salary_records: [{id:0}],
      expense_status_id: 3,
      invoice_id:null,
      user_id: null,
      salary_type: null,

    };

    const expenditures_APP_STORE_MODULE_NAME = "expenditures";

    if (!store.hasModule(expenditures_APP_STORE_MODULE_NAME))
      store.registerModule(
        expenditures_APP_STORE_MODULE_NAME,
        expenditureStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(expenditures_APP_STORE_MODULE_NAME))
        store.unregisterModule(expenditures_APP_STORE_MODULE_NAME);
    });

    const init = ref(true);
    const refetchData = () => {
      if (router.currentRoute.name.includes("create")) {
        expendituresData.value = expenditures;

        // 先處理URL參數中的user_id
        if(init.value){
          if (router.currentRoute.query.user_id) {
            expendituresData.value.user_id = Number(router.currentRoute.query.user_id);
          }
        }

        if(router.currentRoute.name.includes("salary")) {
          // 初始化薪資記錄，如果有user_id則自動設定
          expendituresData.value.salary_records = [{
            id: 0,
            user_id: expendituresData.value.user_id || null
          }];
        }
      } else {
        store
          .dispatch("expenditures/fetchExpenditure", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            expendituresData.value = response.data.expense;
            expendituresData.value.salary_records = response.data.expense
              .salary_records
              ? response.data.expense.salary_records
              : [];
           

            if (init.value) {
              expendituresData.value.year_month = new Date(`${expendituresData.value.salary_year}-${expendituresData.value.salary_month}-01`)
              init.value = false;
            }
          })
          .catch((error) => {
            console.log("error when fetching expenditures", error);
            if (error.response.status === 404) {
              expendituresData.value = undefined;
            }
          });
      }
    };

    const invoiceOptions = ref([]);
    const workerOptions = ref([]);
    const approvalStatusOptions = ref([]);
    const expenseStatusOptions = ref([]);
    const userOptions = ref([]);
    const salaryReceiveMethodOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          invoices: true,
          workers: true,
          approve_status: true,
          expense_statuses: true,
          users: true,
          receive_methods: true,
        })
        .then((response) => {
          invoiceOptions.value = response.data.invoices;
          workerOptions.value = response.data.workers;
          approvalStatusOptions.value = response.data.approve_statuses;
          expenseStatusOptions.value = response.data.expense_statuses;
          userOptions.value = response.data.users;
          salaryReceiveMethodOptions.value = response.data.receive_methods.filter(ele=> ele.id!=18).sort ((a, b) => a.sort_order - b.sort_order);

          // 確保選項載入完成後再載入資料
          refetchData();
        });
    };



    onMounted(() => {
      refetchOption();
    });

    return {
      expendituresData,
      invoiceOptions,
      workerOptions,
      approvalStatusOptions,
      refetchOption,
      refetchData,
      expenseStatusOptions,
      userOptions,
      salaryReceiveMethodOptions,
    };
  },
};
</script>
